module.exports = __webpack_public_path__ + "static/media/gl.2490aa08.svg";